import React from "react";

import { confirmDelivery } from "../modules/refill/confirmDelivery";

import { ConfirmOrderActionPage } from "./ConfirmOrderActionPage";

export const ConfirmDeliveryPage = () => (
  <ConfirmOrderActionPage
    apiCall={confirmDelivery}
    successToast="Your medication delivery has been confirmed"
    loadingText="Confirming delivery..."
  />
);
